import { dashboard } from './dashboard/dashboard'
import { fundraisingPages } from './fundraising-pages/fundraising-pages'
import HomePage from './home-page/home-page'
import Leaderboard from './leaderboard/leaderboard'
import { navigation } from './navigation/navigation'
import Page from './page/page'
import Registration, { registration } from './registration/registration'
import Search from './components/widgets/search/search'
import ProgressBar from './components/widgets/progress-bar/progress-bar'

export const p2p = () => {
  checkLogin()
  navigation()
  registration()
  dashboard()
  fundraisingPages()

  window.addEventListener('load', () => {
    new Page()
    new HomePage()
    new Leaderboard()
    new Registration()
    new Search()
    new ProgressBar()

    setTimeout(() => {
      document.body.classList.add('show')
    }, 600)
  })
}

const checkLogin = () => {
  if (enSession && enSession.loggedIn) {
    document.body.classList.add('logged-in')
  } else {
    document.body.classList.remove('logged-in')
  }
}
